import { NgModule } from '@angular/core';
import { AuthService } from './auth.service';
import { AuthResetPasswordComponent } from './resetPassword/resetPassword.component';
import { GlobalModule } from '../global/global.module';
import { UIRouterModule } from '@uirouter/angular';
import { STATES } from './auth.states';
import { AuthProfileComponent } from './profile/profile.component';

@NgModule({
  declarations: [
    AuthProfileComponent,
    AuthResetPasswordComponent
  ],
  providers: [
    AuthService
  ],
  imports: [
    GlobalModule,
    UIRouterModule.forChild({states: STATES})
  ]
})
export class AuthModule {
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts